var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 168,
    viewBox: "0 0 145 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.958 125.986C100.372 149.443 55.611 147.114 15.9829 120.787C-23.6452 94.4591 -43.1285 54.093 -27.543 30.6354C-11.9574 7.1778 32.8039 9.5066 72.432 35.8342C112.06 62.1618 131.543 102.528 115.958 125.986Z",
    fill: "url(#paint0_linear_502_8466)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.192 127.133C99.6065 150.591 54.8451 148.268 15.2171 121.935C-24.4056 95.607 -43.8943 55.2409 -28.3088 31.7833C-12.7232 8.32574 32.0381 10.6546 71.6662 36.9822C111.294 63.3153 130.778 103.676 115.192 127.133Z",
    fill: "url(#paint1_linear_502_8466)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.815 127.708C99.016 151.482 54.0852 149.416 14.4571 123.083C-25.1709 96.7551 -44.4848 56.1321 -28.686 32.3574C-12.8873 8.58274 32.0435 10.6546 71.6716 36.9822C111.3 63.3153 130.614 103.933 114.815 127.708Z",
    fill: "url(#paint2_linear_502_8466)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.05 128.855C98.2512 152.63 53.3204 150.558 13.6923 124.231C-25.9303 97.903 -45.2496 57.28 -29.4509 33.5054C-13.6521 9.73069 31.2787 11.8026 70.9067 38.1302C110.535 64.4633 129.849 105.081 114.05 128.855Z",
    fill: "url(#paint3_linear_502_8466)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.29 130.003C97.4911 153.778 52.5603 151.712 12.9322 125.379C-26.6958 99.051 -46.0097 58.428 -30.2109 34.6533C-14.4122 10.8786 30.5186 12.9505 70.1467 39.2781C109.775 65.6112 129.089 106.229 113.29 130.003Z",
    fill: "url(#paint4_linear_502_8466)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.525 131.152C96.7258 154.926 51.795 152.86 12.1669 126.527C-27.4557 100.199 -46.775 59.5762 -30.9763 35.8015C-15.1775 12.0268 29.7533 14.0987 69.3813 40.4263C109.009 66.7594 128.323 107.377 112.525 131.152Z",
    fill: "url(#paint5_linear_502_8466)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.764 132.299C95.9657 156.074 51.0349 154.008 11.4069 127.675C-28.2212 101.347 -47.5351 60.7239 -31.7363 36.9492C-15.9376 13.1745 28.9932 15.2464 68.6213 41.574C108.249 67.9016 127.563 108.525 111.764 132.299Z",
    fill: "url(#paint6_linear_502_8466)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.999 133.448C95.2004 157.222 50.2696 155.156 10.6415 128.823C-28.9811 102.495 -48.3004 61.8721 -32.5017 38.0974C-16.7029 14.3227 28.2279 16.3946 67.856 42.7222C107.484 69.0553 126.798 109.673 110.999 133.448Z",
    fill: "url(#paint7_linear_502_8466)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.234 134.595C94.4354 158.37 49.5046 156.298 9.87655 129.971C-29.7461 103.643 -49.0599 63.02 -33.2666 39.2453C-17.4679 15.4707 27.4629 17.5426 67.091 43.8702C106.719 70.2032 126.033 110.821 110.234 134.595Z",
    fill: "url(#paint8_linear_502_8466)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M109.474 135.744C93.6755 159.518 48.7447 157.452 9.11661 131.119C-30.506 104.791 -49.8253 64.1682 -34.0266 40.3935C-18.2278 16.6189 26.703 18.6908 66.3311 45.0184C105.959 71.3514 125.273 111.969 109.474 135.744Z",
    fill: "url(#paint9_linear_502_8466)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M108.709 136.892C92.9098 160.666 47.9791 158.6 8.35098 132.267C-31.2716 105.939 -50.5909 65.3161 -34.7922 41.5415C-18.9934 17.7668 25.9373 19.8387 65.5654 46.1663C105.194 72.4994 124.507 113.117 108.709 136.892Z",
    fill: "url(#paint10_linear_502_8466)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M116.725 124.821C132.312 101.361 112.823 60.9998 73.196 34.6715C33.5688 8.3433 -11.1909 6.0181 -26.7777 29.4781C-42.3644 52.938 -22.8758 93.2993 16.7513 119.628C56.3785 145.956 101.138 148.281 116.725 124.821Z",
    fill: "#0C0232"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M107.024 118.398C93.5436 138.685 54.8339 136.673 20.5632 113.899C-13.7075 91.1243 -30.5614 56.2195 -17.0805 35.9271C-3.59962 15.6402 35.1101 17.652 69.3863 40.4262C103.657 63.2005 120.511 98.1053 107.03 118.398H107.024Z",
    fill: "#0C0232"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.024 118.398C93.5436 138.685 54.8339 136.673 20.5632 113.899C-13.7075 91.1243 -30.5614 56.2195 -17.0805 35.9271C-3.59962 15.6402 35.1101 17.652 69.3863 40.4262C103.657 63.2005 120.511 98.1053 107.03 118.398H107.024Z",
    fill: "url(#paint11_linear_502_8466)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.782 123.553C99.6178 146.376 56.0646 144.113 17.508 118.496C-21.0486 92.8737 -40.0071 53.601 -24.8425 30.7775C-9.6779 7.95406 33.8753 10.2173 72.4319 35.8342C110.988 61.4512 129.947 100.724 114.782 123.547V123.553ZM20.5584 113.904C54.8291 136.678 93.5443 138.69 107.025 118.403C120.506 98.1163 103.652 63.206 69.3815 40.4317C35.1107 17.6574 -3.6044 15.6457 -17.0853 35.9326C-30.5661 56.2195 -13.7123 91.1299 20.5584 113.904Z",
    fill: "url(#paint12_linear_502_8466)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9861 60.3868L44.8391 50.8349C44.7533 50.7726 44.6412 50.7426 44.5275 50.7515C44.4138 50.7605 44.3078 50.8076 44.2329 50.8826L31.0001 64.1154C30.8348 64.2805 30.7276 64.4818 30.6912 64.695C30.6549 64.9083 30.691 65.1245 30.7952 65.3176L42.7578 87.0843C42.8634 87.2761 42.9007 87.4914 42.8652 87.7039C42.8298 87.9165 42.723 88.1172 42.5579 88.2815L35.3433 95.4962C35.3045 95.5336 35.2748 95.5771 35.2558 95.6241C35.2369 95.6712 35.2291 95.7208 35.233 95.77C35.2368 95.8192 35.2523 95.8669 35.2784 95.9104C35.3044 95.9539 35.3406 95.9923 35.3848 96.0231L48.5318 105.575C48.5746 105.607 48.6247 105.632 48.6793 105.647C48.7338 105.662 48.7916 105.667 48.8492 105.663C48.9068 105.658 48.963 105.644 49.0145 105.62C49.066 105.597 49.1117 105.565 49.1489 105.526L62.3513 92.324C62.5166 92.1589 62.6239 91.9576 62.6602 91.7444C62.6966 91.5311 62.6605 91.3149 62.5563 91.1218L50.5936 69.3551C50.4884 69.1622 50.4518 68.9458 50.4882 68.7324C50.5246 68.5189 50.6324 68.3176 50.7985 68.1529L58.0384 60.913C58.0755 60.8746 58.1035 60.8306 58.1209 60.7834C58.1383 60.7362 58.1448 60.6868 58.14 60.6379C58.1351 60.5891 58.119 60.5417 58.0926 60.4987C58.0662 60.4556 58.03 60.4176 57.9861 60.3868Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0175 65.9863L58.9268 72.077C58.8222 72.1876 58.7552 72.3201 58.7334 72.4594C58.7117 72.5986 58.736 72.7388 58.8037 72.8639L66.6005 87.2918C66.6299 87.3468 66.6753 87.3941 66.7323 87.4295C66.7894 87.4648 66.8564 87.4869 66.9272 87.494C66.998 87.501 67.0704 87.4926 67.1377 87.4696C67.2051 87.4466 67.2652 87.4097 67.3127 87.3623L78.7277 75.9474C78.7655 75.9096 78.7943 75.8661 78.8127 75.8192C78.831 75.7724 78.8383 75.7233 78.8343 75.6747C78.8304 75.6261 78.8151 75.5791 78.7894 75.5363C78.7637 75.4935 78.7282 75.4558 78.6848 75.4255L65.6288 65.9397C65.5868 65.908 65.5376 65.8841 65.4839 65.8693C65.4303 65.8544 65.3733 65.849 65.3164 65.8534C65.2595 65.8577 65.2038 65.8717 65.1524 65.8945C65.1011 65.9173 65.0552 65.9485 65.0175 65.9863Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3648 90.4224L34.462 84.3252C34.5659 84.2142 34.6325 84.0816 34.6543 83.9424C34.6762 83.8032 34.6524 83.6631 34.5856 83.5377L26.7791 69.1197C26.748 69.0654 26.7015 69.0191 26.6437 68.9847C26.5859 68.9503 26.5186 68.929 26.4477 68.9225C26.3769 68.9161 26.3046 68.9248 26.2372 68.9478C26.1699 68.9708 26.1095 69.0075 26.0615 69.0545L14.6546 80.4614C14.6161 80.4986 14.5863 80.5418 14.567 80.5884C14.5477 80.635 14.5393 80.6841 14.5422 80.7328C14.5452 80.7815 14.5595 80.8288 14.5842 80.8721C14.609 80.9153 14.6437 80.9535 14.6864 80.9845L27.7481 90.4744C27.8348 90.5374 27.9485 90.5674 28.0642 90.5576C28.1799 90.5479 28.288 90.4992 28.3648 90.4224Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.986 60.3868L44.839 50.8349C44.7532 50.7726 44.6411 50.7426 44.5274 50.7516C44.4137 50.7605 44.3077 50.8077 44.2328 50.8826L31 64.1154C30.8347 64.2805 30.7275 64.4818 30.6911 64.695C30.6548 64.9083 30.6909 65.1245 30.7951 65.3176L42.7577 87.0843C42.8633 87.2761 42.9006 87.4914 42.8652 87.7039C42.8297 87.9165 42.7229 88.1172 42.5579 88.2815L35.3432 95.4962C35.3044 95.5336 35.2747 95.5771 35.2557 95.6241C35.2368 95.6712 35.229 95.7208 35.2329 95.77C35.2368 95.8192 35.2522 95.8669 35.2783 95.9104C35.3044 95.9539 35.3405 95.9923 35.3847 96.0232L48.5318 105.575C48.5745 105.607 48.6247 105.632 48.6792 105.647C48.7337 105.662 48.7915 105.667 48.8491 105.663C48.9067 105.658 48.9629 105.644 49.0144 105.62C49.0659 105.597 49.1116 105.565 49.1488 105.527L62.3513 92.324C62.5165 92.1589 62.6238 91.9576 62.6601 91.7444C62.6965 91.5311 62.6604 91.315 62.5562 91.1218L50.5935 69.3551C50.4884 69.1622 50.4517 68.9458 50.4881 68.7324C50.5245 68.5189 50.6323 68.3176 50.7984 68.1529L58.0383 60.913C58.0754 60.8746 58.1034 60.8306 58.1208 60.7834C58.1383 60.7362 58.1447 60.6868 58.1399 60.6379C58.135 60.5891 58.1189 60.5417 58.0925 60.4987C58.0661 60.4556 58.03 60.4176 57.986 60.3868Z",
    fill: "url(#paint13_linear_502_8466)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0177 65.9864L58.927 72.0771C58.8225 72.1877 58.7555 72.3202 58.7337 72.4594C58.7119 72.5987 58.7363 72.7389 58.804 72.864L66.6008 87.2919C66.6302 87.3469 66.6755 87.3942 66.7326 87.4295C66.7896 87.4649 66.8566 87.487 66.9274 87.494C66.9982 87.5011 67.0706 87.4927 67.138 87.4697C67.2053 87.4467 67.2655 87.4098 67.313 87.3624L78.7279 75.9474C78.7657 75.9097 78.7946 75.8661 78.8129 75.8193C78.8312 75.7725 78.8386 75.7234 78.8346 75.6748C78.8306 75.6262 78.8153 75.5791 78.7896 75.5363C78.764 75.4935 78.7284 75.4559 78.6851 75.4255L65.6291 65.9398C65.5871 65.9081 65.5378 65.8842 65.4842 65.8693C65.4305 65.8545 65.3736 65.8491 65.3167 65.8534C65.2598 65.8578 65.204 65.8718 65.1527 65.8946C65.1013 65.9174 65.0555 65.9486 65.0177 65.9864Z",
    fill: "url(#paint14_linear_502_8466)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3642 90.4225L34.4614 84.3253C34.5653 84.2142 34.6319 84.0816 34.6537 83.9425C34.6756 83.8033 34.6517 83.6631 34.585 83.5378L26.7785 69.1198C26.7473 69.0655 26.7008 69.0192 26.6431 68.9848C26.5853 68.9504 26.518 68.9291 26.4471 68.9226C26.3762 68.9162 26.3039 68.9248 26.2366 68.9479C26.1692 68.9709 26.1089 69.0075 26.0609 69.0546L14.654 80.4615C14.6155 80.4987 14.5857 80.5419 14.5664 80.5885C14.5471 80.6351 14.5386 80.6842 14.5416 80.7329C14.5445 80.7816 14.5588 80.8289 14.5836 80.8721C14.6083 80.9153 14.6431 80.9536 14.6858 80.9846L27.7474 90.4745C27.8342 90.5375 27.9479 90.5674 28.0636 90.5577C28.1792 90.5479 28.2874 90.4993 28.3642 90.4225Z",
    fill: "url(#paint15_linear_502_8466)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_8466",
    x1: -29.4508,
    y1: 32.1989,
    x2: 121.315,
    y2: 126.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_502_8466",
    x1: -30.1784,
    y1: 33.3687,
    x2: 120.582,
    y2: 127.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_502_8466",
    x1: -30.5447,
    y1: 33.9537,
    x2: 120.216,
    y2: 128.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_502_8466",
    x1: -31.2768,
    y1: 35.118,
    x2: 119.489,
    y2: 129.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_502_8466",
    x1: -32.0095,
    y1: 36.2878,
    x2: 118.757,
    y2: 130.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_502_8466",
    x1: -32.7366,
    y1: 37.4524,
    x2: 118.024,
    y2: 131.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_502_8466",
    x1: -33.4693,
    y1: 38.622,
    x2: 117.291,
    y2: 133.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_502_8466",
    x1: -34.2018,
    y1: 39.7921,
    x2: 116.564,
    y2: 134.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_502_8466",
    x1: -34.934,
    y1: 40.9564,
    x2: 115.832,
    y2: 135.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_502_8466",
    x1: -35.6611,
    y1: 42.1265,
    x2: 115.099,
    y2: 136.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_502_8466",
    x1: -36.3939,
    y1: 43.2963,
    x2: 114.367,
    y2: 137.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3A2484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_502_8466",
    x1: 112.836,
    y1: 22.0472,
    x2: 17.644,
    y2: 99.3572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A2484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2484",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_502_8466",
    x1: -30.0687,
    y1: 77.1625,
    x2: 120.009,
    y2: 77.1625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D189F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9222FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF0CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_502_8466",
    x1: 14.5543,
    y1: 78.2071,
    x2: 78.8223,
    y2: 78.2071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_502_8466",
    x1: 14.5543,
    y1: 78.2071,
    x2: 78.8223,
    y2: 78.2071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_502_8466",
    x1: 14.5543,
    y1: 78.2071,
    x2: 78.8223,
    y2: 78.2071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin1);
export default __webpack_public_path__ + "static/media/coin1.ef9bb7c2.svg";
export { ForwardRef as ReactComponent };